import { Component, DestroyRef, OnInit, signal, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { Toast } from 'primeng/toast';
import { AppStateService } from './core/services/common/app-state.service';
import { ThemeSettingsService } from './core/services/common/theme-settings.service';
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Toast],
  templateUrl: './app.html',
})
export class App implements OnInit {
  private router = inject(Router);
  private appState=inject(AppStateService)
  // Created here so the colours, fonts and layout chosen in the Settings panel are applied from the first page.
  private readonly themeSettings = inject(ThemeSettingsService);
  private readonly destroyRef = inject(DestroyRef);
  constructor() {
    this.appState.updateState();
  }
  protected readonly title = signal('Ynex-Tailwind');
  ngOnInit() {
    this.router.events.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((event) => {
      if (event instanceof NavigationEnd) {
        setTimeout(() => window.HSStaticMethods.autoInit(), 100);
      }
    });
  }

}
 
